import { Action, ElMessage, ElMessageBox, ElNotification } from 'element-plus'
export const useMessage = () => {
  return {
    // 消息提示
    info(content: string) {
      ElMessage.info(content)
    },
    // 错误消息
    error(content: string) {
      ElMessage.error(content)
    },
    // 成功消息
    success(content: string) {
      ElMessage.success(content)
    },
    // 警告消息
    warning(content: string) {
      ElMessage.warning(content)
    },
    // 弹出提示
    alert(content: string) {
      ElMessageBox.alert(content, '系统提示')
    },
    // 错误提示
    alertError(content: string) {
      ElMessageBox.alert(content, '系统提示', { type: 'error' })
    },
    // 成功提示
    alertSuccess(content: string) {
      ElMessageBox.alert(content, '系统提示', { type: 'success' })
    },
    // 警告提示
    alertWarning(content: string) {
      ElMessageBox.alert(content, '系统提示', { type: 'warning' })
    },
    // 警告提示
    alertConfirm(
      content: string,
      title: string,
      dangerouslyUseHTMLString = false,
      confirmButtonText: string
    ) {
      return new Promise((resolve) => {
        ElMessageBox.alert(content, title, {
          dangerouslyUseHTMLString: dangerouslyUseHTMLString,
          confirmButtonText: confirmButtonText,
          callback: (action: Action) => {
            if (action === 'confirm') {
              resolve(true)
            } else {
              resolve(false)
            }
          }
        })
      })
    },
    // 通知提示
    notify(content: string) {
      ElNotification.info(content)
    },
    // 错误通知
    notifyError(content: string) {
      ElNotification.error(content)
    },
    // 成功通知
    notifySuccess(content: string) {
      ElNotification.success(content)
    },
    // 警告通知
    notifyWarning(content: string) {
      ElNotification.warning(content)
    },
    // 确认窗体
    confirm(content: string, tip?: string, params?: { confirmButtonText?: string, cancelButtonText?: string }) {
      
      return ElMessageBox.confirm(content, tip ? tip : '系统提示', {
        confirmButtonText: params?.confirmButtonText||'确定',
        cancelButtonText: params?.cancelButtonText||'取消',
        type: 'warning'
      })
    },
    // 删除窗体
    delConfirm(content?: string, tip?: string) {
      return ElMessageBox.confirm(
        content ? content : '是否删除所选中数据？',
        tip ? tip : '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
    },
    // 导出窗体
    exportConfirm(content?: string, tip?: string) {
      return ElMessageBox.confirm(
        content ? content : '是否确认导出数据项？',
        tip ? tip : '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
    },
    // 提交内容
    prompt(content: string, tip: string) {
      return ElMessageBox.prompt(content, tip, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    }
  }
}
